/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import L from 'leaflet';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { finabeelight, finabeeoutline, finabeesingle, logoDynomo } from './components/icons/icon';
import { CircularProgress } from '@mui/material';
import { Provider } from 'react-redux';
import store from '../src/storeTolkit/store.tsx'
import { APP_VERSION } from './version';
const App = lazy(() => import('./App'))
const LOCAL_VERSION_KEY = "app_version";

L.Control.Attribution.prototype.options.prefix = "Speak Logic";

const savedVersion = localStorage.getItem(LOCAL_VERSION_KEY);
if (savedVersion !== APP_VERSION) {
  // Clear old storage
  localStorage.clear();

  // Save new version
  localStorage.setItem(LOCAL_VERSION_KEY, APP_VERSION);

  console.log("✨ New build detected — localStorage cleared");
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={
    <main className='h-screen flex flex-col justify-center items-center'>
      <CircularProgress className='text_darkprimary' size={40} thickness={2} />
      {/* <img style={{ width: '2rem', height: "auto" }} src={finabeesingle} className='absolute' alt="" /> */}
    </main>
  }>  
    <React.StrictMode>  
            <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </Provider>
    </React.StrictMode>
  </Suspense>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
